import { render } from "./CadastroCarreta.vue?vue&type=template&id=d85de032"
import script from "./CadastroCarreta.vue?vue&type=script&lang=ts"
export * from "./CadastroCarreta.vue?vue&type=script&lang=ts"
script.render = render

export default script